import {
  ApolloQueryResult,
  OperationVariables,
  useMutation
} from '@apollo/client'
import { Button, Typography } from '@material-ui/core'
import DeleteIcon from '@material-ui/icons/Delete'
import { useEffect, useState } from 'react'
import { toast } from 'react-toastify'

import { RESET_CART_MUTATION } from '../../graphql/cartCrud'
import { getTranslate } from '../../localization'
import { Cart, CartItem, CartResponse } from '../../types/cart'
import SelectedRoomCard from './components/SelectedRoomCard'
import useStyles from './styles/index.styles'

type StepOneProps = {
  cart: Cart | undefined
  cartID: string
  refetchCart: (variables?: Partial<OperationVariables> | undefined) => Promise<
    ApolloQueryResult<{
      cartResponse: CartResponse
    }>
  >
  clickedItemHash: string
  setClickedItemHash: React.Dispatch<React.SetStateAction<string>>
  loadingForGetCart: boolean
  setShowModal: React.Dispatch<React.SetStateAction<boolean>>
  setRedirectTitle: React.Dispatch<React.SetStateAction<string>>
  setIsTimeExpired: React.Dispatch<React.SetStateAction<boolean>>
}

const StepOne = ({
  cart,
  cartID,
  refetchCart,
  loadingForGetCart,
  setShowModal,
  clickedItemHash,
  setClickedItemHash,
  setRedirectTitle,
  setIsTimeExpired
}: StepOneProps) => {
  const classes = useStyles()
  const [filteredItems, setFilteredItems] = useState<CartItem[]>([])

  useEffect(() => {
    if (cart) {
      setFilteredItems(cart.items)
      setIsTimeExpired(false)
      setShowModal(false)
    }
  }, [cart])

  //RESET_CART_MUTATION
  const [resetCart] = useMutation(RESET_CART_MUTATION, {
    notifyOnNetworkStatusChange: true,
    onCompleted: () => {
      setShowModal(true)
      setRedirectTitle(
        getTranslate(
          'Cart has been empty. you will be redirect to booking page'
        )
      )
    },
    onError: (err) => {
      toast.error(err.message)
    }
  })

  return (
    <>
      {filteredItems.length > 0 ? (
        <div className={classes.header}>
          <Typography variant="h4" className={classes.blackText}>
            {getTranslate('Selected Room(s)')}
          </Typography>
          <Button
            variant="text"
            startIcon={<DeleteIcon />}
            classes={{ startIcon: classes.blueIcon }}
            onClick={() => resetCart({ variables: { cartID: cartID } })}>
            <Typography variant="h5" className={classes.blueText}>
              {getTranslate('Clear Shopping Cart')}
            </Typography>
          </Button>
        </div>
      ) : (
        <></>
      )}
      {filteredItems
        .filter((item) => item.quantity > 0)
        .map((item, index) => (
          <SelectedRoomCard
            key={index}
            cartID={cartID}
            cartItem={item}
            clickedItemHash={clickedItemHash}
            setClickedItemHash={setClickedItemHash}
            refetchCart={refetchCart}
            loadingForGetCart={loadingForGetCart}
            setShowModal={setShowModal}
            setRedirectTitle={setRedirectTitle}
          />
        ))}
    </>
  )
}

export default StepOne
